"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'africa/bamako': {
        u: 0,
        d: 0,
    },
    'africa/banjul': {
        u: 0,
        d: 0,
    },
    'africa/conakry': {
        u: 0,
        d: 0,
    },
    'africa/dakar': {
        u: 0,
        d: 0,
    },
    'africa/freetown': {
        u: 0,
        d: 0,
    },
    'africa/lome': {
        u: 0,
        d: 0,
    },
    'africa/nouakchott': {
        u: 0,
        d: 0,
    },
    'africa/ouagadougou': {
        u: 0,
        d: 0,
    },
    'africa/timbuktu': {
        u: 0,
        d: 0,
    },
    'atlantic/st_helena': {
        u: 0,
        d: 0,
    },
    egypt: {
        u: 120,
        d: 120,
    },
    'africa/maseru': {
        u: 120,
        d: 120,
    },
    'africa/mbabane': {
        u: 120,
        d: 120,
    },
    'africa/bangui': {
        u: 60,
        d: 60,
    },
    'africa/brazzaville': {
        u: 60,
        d: 60,
    },
    'africa/douala': {
        u: 60,
        d: 60,
    },
    'africa/kinshasa': {
        u: 60,
        d: 60,
    },
    'africa/libreville': {
        u: 60,
        d: 60,
    },
    'africa/luanda': {
        u: 60,
        d: 60,
    },
    'africa/malabo': {
        u: 60,
        d: 60,
    },
    'africa/niamey': {
        u: 60,
        d: 60,
    },
    'africa/porto-novo': {
        u: 60,
        d: 60,
    },
    'africa/blantyre': {
        u: 120,
        d: 120,
    },
    'africa/bujumbura': {
        u: 120,
        d: 120,
    },
    'africa/gaborone': {
        u: 120,
        d: 120,
    },
    'africa/harare': {
        u: 120,
        d: 120,
    },
    'africa/kigali': {
        u: 120,
        d: 120,
    },
    'africa/lubumbashi': {
        u: 120,
        d: 120,
    },
    'africa/lusaka': {
        u: 120,
        d: 120,
    },
    'africa/addis_ababa': {
        u: 180,
        d: 180,
    },
    'africa/asmara': {
        u: 180,
        d: 180,
    },
    'africa/asmera': {
        u: 180,
        d: 180,
    },
    'africa/dar_es_salaam': {
        u: 180,
        d: 180,
    },
    'africa/djibouti': {
        u: 180,
        d: 180,
    },
    'africa/kampala': {
        u: 180,
        d: 180,
    },
    'africa/mogadishu': {
        u: 180,
        d: 180,
    },
    'indian/antananarivo': {
        u: 180,
        d: 180,
    },
    'indian/comoro': {
        u: 180,
        d: 180,
    },
    'indian/mayotte': {
        u: 180,
        d: 180,
    },
    libya: {
        u: 120,
        d: 120,
    },
    'america/atka': {
        u: -600,
        d: -540,
    },
    'us/aleutian': {
        u: -600,
        d: -540,
    },
    'us/alaska': {
        u: -540,
        d: -480,
    },
    'america/buenos_aires': {
        u: -180,
        d: -180,
    },
    'america/argentina/comodrivadavia': {
        u: -180,
        d: -180,
    },
    'america/catamarca': {
        u: -180,
        d: -180,
    },
    'america/cordoba': {
        u: -180,
        d: -180,
    },
    'america/rosario': {
        u: -180,
        d: -180,
    },
    'america/jujuy': {
        u: -180,
        d: -180,
    },
    'america/mendoza': {
        u: -180,
        d: -180,
    },
    'america/coral_harbour': {
        u: -300,
        d: -300,
    },
    'us/central': {
        u: -360,
        d: -300,
    },
    'america/aruba': {
        u: -240,
        d: -240,
    },
    'america/kralendijk': {
        u: -240,
        d: -240,
    },
    'america/lower_princes': {
        u: -240,
        d: -240,
    },
    'america/shiprock': {
        u: -420,
        d: -360,
    },
    navajo: {
        u: -420,
        d: -360,
    },
    'us/mountain': {
        u: -420,
        d: -360,
    },
    'us/michigan': {
        u: -300,
        d: -240,
    },
    'canada/mountain': {
        u: -420,
        d: -360,
    },
    'america/indiana/indianapolis': {
        u: -300,
        d: -240,
    },
    'america/nuuk': {
        u: -180,
        d: -120,
    },
    'canada/atlantic': {
        u: -240,
        d: -180,
    },
    cuba: {
        u: -300,
        d: -240,
    },
    'america/knox_in': {
        u: -360,
        d: -300,
    },
    'us/indiana-starke': {
        u: -360,
        d: -300,
    },
    jamaica: {
        u: -300,
        d: -300,
    },
    'america/louisville': {
        u: -300,
        d: -240,
    },
    'us/pacific': {
        u: -480,
        d: -420,
    },
    'brazil/west': {
        u: -240,
        d: -240,
    },
    'mexico/bajasur': {
        u: -420,
        d: -360,
    },
    'mexico/general': {
        u: -360,
        d: -300,
    },
    'us/eastern': {
        u: -300,
        d: -240,
    },
    'brazil/denoronha': {
        u: -120,
        d: -120,
    },
    'america/cayman': {
        u: -300,
        d: -300,
    },
    'us/arizona': {
        u: -420,
        d: -420,
    },
    'america/anguilla': {
        u: -240,
        d: -240,
    },
    'america/antigua': {
        u: -240,
        d: -240,
    },
    'america/dominica': {
        u: -240,
        d: -240,
    },
    'america/grenada': {
        u: -240,
        d: -240,
    },
    'america/guadeloupe': {
        u: -240,
        d: -240,
    },
    'america/marigot': {
        u: -240,
        d: -240,
    },
    'america/montserrat': {
        u: -240,
        d: -240,
    },
    'america/st_barthelemy': {
        u: -240,
        d: -240,
    },
    'america/st_kitts': {
        u: -240,
        d: -240,
    },
    'america/st_lucia': {
        u: -240,
        d: -240,
    },
    'america/st_thomas': {
        u: -240,
        d: -240,
    },
    'america/st_vincent': {
        u: -240,
        d: -240,
    },
    'america/tortola': {
        u: -240,
        d: -240,
    },
    'america/virgin': {
        u: -240,
        d: -240,
    },
    'canada/saskatchewan': {
        u: -360,
        d: -360,
    },
    'america/porto_acre': {
        u: -300,
        d: -300,
    },
    'brazil/acre': {
        u: -300,
        d: -300,
    },
    'chile/continental': {
        u: -240,
        d: -180,
    },
    'brazil/east': {
        u: -180,
        d: -180,
    },
    'canada/newfoundland': {
        u: -210,
        d: -150,
    },
    'america/ensenada': {
        u: -480,
        d: -420,
    },
    'america/santa_isabel': {
        u: -480,
        d: -420,
    },
    'mexico/bajanorte': {
        u: -480,
        d: -420,
    },
    'america/montreal': {
        u: -300,
        d: -240,
    },
    'canada/eastern': {
        u: -300,
        d: -240,
    },
    'canada/pacific': {
        u: -480,
        d: -420,
    },
    'canada/yukon': {
        u: -420,
        d: -420,
    },
    'canada/central': {
        u: -360,
        d: -300,
    },
    'asia/ashkhabad': {
        u: 300,
        d: 300,
    },
    'asia/phnom_penh': {
        u: 420,
        d: 420,
    },
    'asia/vientiane': {
        u: 420,
        d: 420,
    },
    'asia/dacca': {
        u: 360,
        d: 360,
    },
    'asia/muscat': {
        u: 240,
        d: 240,
    },
    'asia/saigon': {
        u: 420,
        d: 420,
    },
    hongkong: {
        u: 480,
        d: 480,
    },
    'asia/tel_aviv': {
        u: 120,
        d: 180,
    },
    israel: {
        u: 120,
        d: 180,
    },
    'asia/katmandu': {
        u: 345,
        d: 345,
    },
    'asia/calcutta': {
        u: 330,
        d: 330,
    },
    'asia/singapore': {
        u: 480,
        d: 480,
    },
    'asia/macao': {
        u: 480,
        d: 480,
    },
    'asia/ujung_pandang': {
        u: 480,
        d: 480,
    },
    'europe/nicosia': {
        u: 120,
        d: 180,
    },
    'asia/bahrain': {
        u: 180,
        d: 180,
    },
    'asia/yangon': {
        u: 390,
        d: 390,
    },
    'asia/aden': {
        u: 180,
        d: 180,
    },
    'asia/kuwait': {
        u: 180,
        d: 180,
    },
    rok: {
        u: 540,
        d: 540,
    },
    'asia/chongqing': {
        u: 480,
        d: 480,
    },
    'asia/chungking': {
        u: 480,
        d: 480,
    },
    'asia/harbin': {
        u: 480,
        d: 480,
    },
    prc: {
        u: 480,
        d: 480,
    },
    roc: {
        u: 480,
        d: 480,
    },
    iran: {
        u: 210,
        d: 270,
    },
    'asia/thimbu': {
        u: 360,
        d: 360,
    },
    japan: {
        u: 540,
        d: 540,
    },
    'asia/ulan_bator': {
        u: 480,
        d: 480,
    },
    'asia/kashgar': {
        u: 360,
        d: 360,
    },
    'atlantic/faeroe': {
        u: 0,
        d: 60,
    },
    iceland: {
        u: 0,
        d: 0,
    },
    'etc/gmt+2': {
        u: -120,
        d: -120,
    },
    'australia/south': {
        u: 570,
        d: 630,
    },
    'australia/queensland': {
        u: 600,
        d: 600,
    },
    'australia/yancowinna': {
        u: 570,
        d: 630,
    },
    'australia/north': {
        u: 570,
        d: 570,
    },
    'australia/currie': {
        u: 600,
        d: 660,
    },
    'australia/tasmania': {
        u: 600,
        d: 660,
    },
    'australia/lhi': {
        u: 630,
        d: 660,
    },
    'australia/victoria': {
        u: 600,
        d: 660,
    },
    'australia/west': {
        u: 480,
        d: 480,
    },
    'australia/act': {
        u: 600,
        d: 660,
    },
    'australia/canberra': {
        u: 600,
        d: 660,
    },
    'australia/nsw': {
        u: 600,
        d: 660,
    },
    'etc/gmt': {
        u: 0,
        d: 0,
    },
    'etc/gmt+0': {
        u: 0,
        d: 0,
    },
    'etc/gmt0': {
        u: 0,
        d: 0,
    },
    'etc/greenwich': {
        u: 0,
        d: 0,
    },
    gmt: {
        u: 0,
        d: 0,
    },
    'gmt+0': {
        u: 0,
        d: 0,
    },
    'gmt-0': {
        u: 0,
        d: 0,
    },
    gmt0: {
        u: 0,
        d: 0,
    },
    greenwich: {
        u: 0,
        d: 0,
    },
    'etc/uct': {
        u: 0,
        d: 0,
    },
    'etc/universal': {
        u: 0,
        d: 0,
    },
    'etc/zulu': {
        u: 0,
        d: 0,
    },
    uct: {
        u: 0,
        d: 0,
    },
    utc: {
        u: 0,
        d: 0,
    },
    universal: {
        u: 0,
        d: 0,
    },
    zulu: {
        u: 0,
        d: 0,
    },
    'europe/ljubljana': {
        u: 60,
        d: 120,
    },
    'europe/podgorica': {
        u: 60,
        d: 120,
    },
    'europe/sarajevo': {
        u: 60,
        d: 120,
    },
    'europe/skopje': {
        u: 60,
        d: 120,
    },
    'europe/zagreb': {
        u: 60,
        d: 120,
    },
    'europe/tiraspol': {
        u: 120,
        d: 180,
    },
    eire: {
        u: 0,
        d: 60,
    },
    'europe/mariehamn': {
        u: 120,
        d: 180,
    },
    'asia/istanbul': {
        u: 180,
        d: 180,
    },
    turkey: {
        u: 180,
        d: 180,
    },
    portugal: {
        u: 0,
        d: 60,
    },
    'europe/belfast': {
        u: 0,
        d: 60,
    },
    'europe/guernsey': {
        u: 0,
        d: 60,
    },
    'europe/isle_of_man': {
        u: 0,
        d: 60,
    },
    'europe/jersey': {
        u: 0,
        d: 60,
    },
    gb: {
        u: 0,
        d: 60,
    },
    'gb-eire': {
        u: 0,
        d: 60,
    },
    'arctic/longyearbyen': {
        u: 60,
        d: 120,
    },
    'atlantic/jan_mayen': {
        u: 60,
        d: 120,
    },
    'europe/bratislava': {
        u: 60,
        d: 120,
    },
    'europe/san_marino': {
        u: 60,
        d: 120,
    },
    'europe/vatican': {
        u: 60,
        d: 120,
    },
    poland: {
        u: 60,
        d: 120,
    },
    'europe/busingen': {
        u: 60,
        d: 120,
    },
    'europe/vaduz': {
        u: 60,
        d: 120,
    },
    'etc/gmt-7': {
        u: 420,
        d: 420,
    },
    'antarctica/mcmurdo': {
        u: 720,
        d: 780,
    },
    'antarctica/south_pole': {
        u: 720,
        d: 780,
    },
    nz: {
        u: 720,
        d: 780,
    },
    'nz-chat': {
        u: 765,
        d: 825,
    },
    'pacific/truk': {
        u: 600,
        d: 600,
    },
    'pacific/yap': {
        u: 600,
        d: 600,
    },
    'chile/easterisland': {
        u: -360,
        d: -300,
    },
    'pacific/saipan': {
        u: 600,
        d: 600,
    },
    'pacific/johnston': {
        u: -600,
        d: -600,
    },
    'us/hawaii': {
        u: -600,
        d: -600,
    },
    kwajalein: {
        u: 720,
        d: 720,
    },
    'pacific/midway': {
        u: -660,
        d: -660,
    },
    'pacific/samoa': {
        u: -660,
        d: -660,
    },
    'us/samoa': {
        u: -660,
        d: -660,
    },
    'etc/gmt-9': {
        u: 540,
        d: 540,
    },
    'pacific/ponape': {
        u: 660,
        d: 660,
    },
    'etc/gmt-10': {
        u: 600,
        d: 600,
    },
    'etc/gmt-12': {
        u: 720,
        d: 720,
    },
    'pacific/funafuti': {
        u: 720,
        d: 720,
    },
    'pacific/wake': {
        u: 720,
        d: 720,
    },
    'pacific/wallis': {
        u: 720,
        d: 720,
    },
    'africa/abidjan': {
        u: 0,
        d: 0,
    },
    'africa/accra': {
        u: 0,
        d: 0,
    },
    'africa/nairobi': {
        u: 180,
        d: 180,
    },
    'africa/algiers': {
        u: 60,
        d: 60,
    },
    'africa/lagos': {
        u: 60,
        d: 60,
    },
    'africa/bissau': {
        u: 0,
        d: 0,
    },
    'africa/maputo': {
        u: 120,
        d: 120,
    },
    'africa/cairo': {
        u: 120,
        d: 120,
    },
    'africa/casablanca': {
        u: 0,
        d: 60,
    },
    'africa/ceuta': {
        u: 60,
        d: 120,
    },
    'africa/el_aaiun': {
        u: 0,
        d: 60,
    },
    'africa/johannesburg': {
        u: 120,
        d: 120,
    },
    'africa/juba': {
        u: 120,
        d: 120,
    },
    'africa/khartoum': {
        u: 120,
        d: 120,
    },
    'africa/monrovia': {
        u: 0,
        d: 0,
    },
    'africa/ndjamena': {
        u: 60,
        d: 60,
    },
    'africa/sao_tome': {
        u: 0,
        d: 0,
    },
    'africa/tripoli': {
        u: 120,
        d: 120,
    },
    'africa/tunis': {
        u: 60,
        d: 60,
    },
    'africa/windhoek': {
        u: 120,
        d: 120,
    },
    'america/adak': {
        u: -600,
        d: -540,
    },
    'america/anchorage': {
        u: -540,
        d: -480,
    },
    'america/port_of_spain': {
        u: -240,
        d: -240,
    },
    'america/araguaina': {
        u: -180,
        d: -180,
    },
    'america/argentina/buenos_aires': {
        u: -180,
        d: -180,
    },
    'america/argentina/catamarca': {
        u: -180,
        d: -180,
    },
    'america/argentina/cordoba': {
        u: -180,
        d: -180,
    },
    'america/argentina/jujuy': {
        u: -180,
        d: -180,
    },
    'america/argentina/la_rioja': {
        u: -180,
        d: -180,
    },
    'america/argentina/mendoza': {
        u: -180,
        d: -180,
    },
    'america/argentina/rio_gallegos': {
        u: -180,
        d: -180,
    },
    'america/argentina/salta': {
        u: -180,
        d: -180,
    },
    'america/argentina/san_juan': {
        u: -180,
        d: -180,
    },
    'america/argentina/san_luis': {
        u: -180,
        d: -180,
    },
    'america/argentina/tucuman': {
        u: -180,
        d: -180,
    },
    'america/argentina/ushuaia': {
        u: -180,
        d: -180,
    },
    'america/curacao': {
        u: -240,
        d: -240,
    },
    'america/asuncion': {
        u: -240,
        d: -180,
    },
    'america/atikokan': {
        u: -300,
        d: -300,
    },
    'america/bahia_banderas': {
        u: -360,
        d: -300,
    },
    'america/bahia': {
        u: -180,
        d: -180,
    },
    'america/barbados': {
        u: -240,
        d: -240,
    },
    'america/belem': {
        u: -180,
        d: -180,
    },
    'america/belize': {
        u: -360,
        d: -360,
    },
    'america/blanc-sablon': {
        u: -240,
        d: -240,
    },
    'america/boa_vista': {
        u: -240,
        d: -240,
    },
    'america/bogota': {
        u: -300,
        d: -300,
    },
    'america/boise': {
        u: -420,
        d: -360,
    },
    'america/cambridge_bay': {
        u: -420,
        d: -360,
    },
    'america/campo_grande': {
        u: -240,
        d: -240,
    },
    'america/cancun': {
        u: -300,
        d: -300,
    },
    'america/caracas': {
        u: -240,
        d: -240,
    },
    'america/cayenne': {
        u: -180,
        d: -180,
    },
    'america/panama': {
        u: -300,
        d: -300,
    },
    'america/chicago': {
        u: -360,
        d: -300,
    },
    'america/chihuahua': {
        u: -420,
        d: -360,
    },
    'america/costa_rica': {
        u: -360,
        d: -360,
    },
    'america/creston': {
        u: -420,
        d: -420,
    },
    'america/cuiaba': {
        u: -240,
        d: -240,
    },
    'america/danmarkshavn': {
        u: 0,
        d: 0,
    },
    'america/dawson_creek': {
        u: -420,
        d: -420,
    },
    'america/dawson': {
        u: -420,
        d: -420,
    },
    'america/denver': {
        u: -420,
        d: -360,
    },
    'america/detroit': {
        u: -300,
        d: -240,
    },
    'america/edmonton': {
        u: -420,
        d: -360,
    },
    'america/eirunepe': {
        u: -300,
        d: -300,
    },
    'america/el_salvador': {
        u: -360,
        d: -360,
    },
    'america/tijuana': {
        u: -480,
        d: -420,
    },
    'america/fort_nelson': {
        u: -420,
        d: -420,
    },
    'america/fortaleza': {
        u: -180,
        d: -180,
    },
    'america/glace_bay': {
        u: -240,
        d: -180,
    },
    'america/goose_bay': {
        u: -240,
        d: -180,
    },
    'america/grand_turk': {
        u: -300,
        d: -240,
    },
    'america/guatemala': {
        u: -360,
        d: -360,
    },
    'america/guayaquil': {
        u: -300,
        d: -300,
    },
    'america/guyana': {
        u: -240,
        d: -240,
    },
    'america/halifax': {
        u: -240,
        d: -180,
    },
    'america/havana': {
        u: -300,
        d: -240,
    },
    'america/hermosillo': {
        u: -420,
        d: -420,
    },
    'america/indiana/knox': {
        u: -360,
        d: -300,
    },
    'america/indiana/marengo': {
        u: -300,
        d: -240,
    },
    'america/indiana/petersburg': {
        u: -300,
        d: -240,
    },
    'america/indiana/tell_city': {
        u: -360,
        d: -300,
    },
    'america/indiana/vevay': {
        u: -300,
        d: -240,
    },
    'america/indiana/vincennes': {
        u: -300,
        d: -240,
    },
    'america/indiana/winamac': {
        u: -300,
        d: -240,
    },
    'america/inuvik': {
        u: -420,
        d: -360,
    },
    'america/iqaluit': {
        u: -300,
        d: -240,
    },
    'america/jamaica': {
        u: -300,
        d: -300,
    },
    'america/juneau': {
        u: -540,
        d: -480,
    },
    'america/kentucky/louisville': {
        u: -300,
        d: -240,
    },
    'america/kentucky/monticello': {
        u: -300,
        d: -240,
    },
    'america/la_paz': {
        u: -240,
        d: -240,
    },
    'america/lima': {
        u: -300,
        d: -300,
    },
    'america/los_angeles': {
        u: -480,
        d: -420,
    },
    'america/maceio': {
        u: -180,
        d: -180,
    },
    'america/managua': {
        u: -360,
        d: -360,
    },
    'america/manaus': {
        u: -240,
        d: -240,
    },
    'america/martinique': {
        u: -240,
        d: -240,
    },
    'america/matamoros': {
        u: -360,
        d: -300,
    },
    'america/mazatlan': {
        u: -420,
        d: -360,
    },
    'america/menominee': {
        u: -360,
        d: -300,
    },
    'america/merida': {
        u: -360,
        d: -300,
    },
    'america/metlakatla': {
        u: -540,
        d: -480,
    },
    'america/mexico_city': {
        u: -360,
        d: -300,
    },
    'america/miquelon': {
        u: -180,
        d: -120,
    },
    'america/moncton': {
        u: -240,
        d: -180,
    },
    'america/monterrey': {
        u: -360,
        d: -300,
    },
    'america/montevideo': {
        u: -180,
        d: -180,
    },
    'america/toronto': {
        u: -300,
        d: -240,
    },
    'america/nassau': {
        u: -300,
        d: -240,
    },
    'america/new_york': {
        u: -300,
        d: -240,
    },
    'america/nipigon': {
        u: -300,
        d: -240,
    },
    'america/nome': {
        u: -540,
        d: -480,
    },
    'america/noronha': {
        u: -120,
        d: -120,
    },
    'america/north_dakota/beulah': {
        u: -360,
        d: -300,
    },
    'america/north_dakota/center': {
        u: -360,
        d: -300,
    },
    'america/north_dakota/new_salem': {
        u: -360,
        d: -300,
    },
    'america/ojinaga': {
        u: -420,
        d: -360,
    },
    'america/pangnirtung': {
        u: -300,
        d: -240,
    },
    'america/paramaribo': {
        u: -180,
        d: -180,
    },
    'america/phoenix': {
        u: -420,
        d: -420,
    },
    'america/port-au-prince': {
        u: -300,
        d: -240,
    },
    'america/rio_branco': {
        u: -300,
        d: -300,
    },
    'america/porto_velho': {
        u: -240,
        d: -240,
    },
    'america/puerto_rico': {
        u: -240,
        d: -240,
    },
    'america/punta_arenas': {
        u: -180,
        d: -180,
    },
    'america/rainy_river': {
        u: -360,
        d: -300,
    },
    'america/rankin_inlet': {
        u: -360,
        d: -300,
    },
    'america/recife': {
        u: -180,
        d: -180,
    },
    'america/regina': {
        u: -360,
        d: -360,
    },
    'america/resolute': {
        u: -360,
        d: -300,
    },
    'america/santarem': {
        u: -180,
        d: -180,
    },
    'america/santiago': {
        u: -240,
        d: -180,
    },
    'america/santo_domingo': {
        u: -240,
        d: -240,
    },
    'america/sao_paulo': {
        u: -180,
        d: -180,
    },
    'america/scoresbysund': {
        u: -60,
        d: -60,
    },
    'america/sitka': {
        u: -540,
        d: -480,
    },
    'america/st_johns': {
        u: -210,
        d: -150,
    },
    'america/swift_current': {
        u: -360,
        d: -360,
    },
    'america/tegucigalpa': {
        u: -360,
        d: -360,
    },
    'america/thule': {
        u: -240,
        d: -180,
    },
    'america/thunder_bay': {
        u: -300,
        d: -240,
    },
    'america/vancouver': {
        u: -480,
        d: -420,
    },
    'america/whitehorse': {
        u: -420,
        d: -420,
    },
    'america/winnipeg': {
        u: -360,
        d: -300,
    },
    'america/yakutat': {
        u: -540,
        d: -480,
    },
    'america/yellowknife': {
        u: -420,
        d: -360,
    },
    'antarctica/casey': {
        u: 660,
        d: 660,
    },
    'antarctica/davis': {
        u: 420,
        d: 420,
    },
    'antarctica/dumontdurville': {
        u: 600,
        d: 600,
    },
    'antarctica/macquarie': {
        u: 600,
        d: 660,
    },
    'antarctica/mawson': {
        u: 300,
        d: 300,
    },
    'pacific/auckland': {
        u: 720,
        d: 780,
    },
    'antarctica/palmer': {
        u: -180,
        d: -180,
    },
    'antarctica/rothera': {
        u: -180,
        d: -180,
    },
    'antarctica/syowa': {
        u: 180,
        d: 180,
    },
    'antarctica/troll': {
        u: 0,
        d: 120,
    },
    'antarctica/vostok': {
        u: 360,
        d: 360,
    },
    'europe/oslo': {
        u: 60,
        d: 120,
    },
    'asia/riyadh': {
        u: 180,
        d: 180,
    },
    'asia/almaty': {
        u: 360,
        d: 360,
    },
    'asia/amman': {
        u: 120,
        d: 180,
    },
    'asia/anadyr': {
        u: 720,
        d: 720,
    },
    'asia/aqtau': {
        u: 300,
        d: 300,
    },
    'asia/aqtobe': {
        u: 300,
        d: 300,
    },
    'asia/ashgabat': {
        u: 300,
        d: 300,
    },
    'asia/atyrau': {
        u: 300,
        d: 300,
    },
    'asia/baghdad': {
        u: 180,
        d: 180,
    },
    'asia/qatar': {
        u: 180,
        d: 180,
    },
    'asia/baku': {
        u: 240,
        d: 240,
    },
    'asia/bangkok': {
        u: 420,
        d: 420,
    },
    'asia/barnaul': {
        u: 420,
        d: 420,
    },
    'asia/beirut': {
        u: 120,
        d: 180,
    },
    'asia/bishkek': {
        u: 360,
        d: 360,
    },
    'asia/brunei': {
        u: 480,
        d: 480,
    },
    'asia/kolkata': {
        u: 330,
        d: 330,
    },
    'asia/chita': {
        u: 540,
        d: 540,
    },
    'asia/choibalsan': {
        u: 480,
        d: 480,
    },
    'asia/shanghai': {
        u: 480,
        d: 480,
    },
    'asia/colombo': {
        u: 330,
        d: 330,
    },
    'asia/dhaka': {
        u: 360,
        d: 360,
    },
    'asia/damascus': {
        u: 120,
        d: 180,
    },
    'asia/dili': {
        u: 540,
        d: 540,
    },
    'asia/dubai': {
        u: 240,
        d: 240,
    },
    'asia/dushanbe': {
        u: 300,
        d: 300,
    },
    'asia/famagusta': {
        u: 120,
        d: 180,
    },
    'asia/gaza': {
        u: 120,
        d: 180,
    },
    'asia/hebron': {
        u: 120,
        d: 180,
    },
    'asia/ho_chi_minh': {
        u: 420,
        d: 420,
    },
    'asia/hong_kong': {
        u: 480,
        d: 480,
    },
    'asia/hovd': {
        u: 420,
        d: 420,
    },
    'asia/irkutsk': {
        u: 480,
        d: 480,
    },
    'europe/istanbul': {
        u: 180,
        d: 180,
    },
    'asia/jakarta': {
        u: 420,
        d: 420,
    },
    'asia/jayapura': {
        u: 540,
        d: 540,
    },
    'asia/jerusalem': {
        u: 120,
        d: 180,
    },
    'asia/kabul': {
        u: 270,
        d: 270,
    },
    'asia/kamchatka': {
        u: 720,
        d: 720,
    },
    'asia/karachi': {
        u: 300,
        d: 300,
    },
    'asia/urumqi': {
        u: 360,
        d: 360,
    },
    'asia/kathmandu': {
        u: 345,
        d: 345,
    },
    'asia/khandyga': {
        u: 540,
        d: 540,
    },
    'asia/krasnoyarsk': {
        u: 420,
        d: 420,
    },
    'asia/kuala_lumpur': {
        u: 480,
        d: 480,
    },
    'asia/kuching': {
        u: 480,
        d: 480,
    },
    'asia/macau': {
        u: 480,
        d: 480,
    },
    'asia/magadan': {
        u: 660,
        d: 660,
    },
    'asia/makassar': {
        u: 480,
        d: 480,
    },
    'asia/manila': {
        u: 480,
        d: 480,
    },
    'asia/nicosia': {
        u: 120,
        d: 180,
    },
    'asia/novokuznetsk': {
        u: 420,
        d: 420,
    },
    'asia/novosibirsk': {
        u: 420,
        d: 420,
    },
    'asia/omsk': {
        u: 360,
        d: 360,
    },
    'asia/oral': {
        u: 300,
        d: 300,
    },
    'asia/pontianak': {
        u: 420,
        d: 420,
    },
    'asia/pyongyang': {
        u: 540,
        d: 540,
    },
    'asia/qostanay': {
        u: 360,
        d: 360,
    },
    'asia/qyzylorda': {
        u: 300,
        d: 300,
    },
    'asia/sakhalin': {
        u: 660,
        d: 660,
    },
    'asia/samarkand': {
        u: 300,
        d: 300,
    },
    'asia/seoul': {
        u: 540,
        d: 540,
    },
    'asia/srednekolymsk': {
        u: 660,
        d: 660,
    },
    'asia/taipei': {
        u: 480,
        d: 480,
    },
    'asia/tashkent': {
        u: 300,
        d: 300,
    },
    'asia/tbilisi': {
        u: 240,
        d: 240,
    },
    'asia/tehran': {
        u: 210,
        d: 270,
    },
    'asia/thimphu': {
        u: 360,
        d: 360,
    },
    'asia/tokyo': {
        u: 540,
        d: 540,
    },
    'asia/tomsk': {
        u: 420,
        d: 420,
    },
    'asia/ulaanbaatar': {
        u: 480,
        d: 480,
    },
    'asia/ust-nera': {
        u: 600,
        d: 600,
    },
    'asia/vladivostok': {
        u: 600,
        d: 600,
    },
    'asia/yakutsk': {
        u: 540,
        d: 540,
    },
    'asia/yekaterinburg': {
        u: 300,
        d: 300,
    },
    'asia/yerevan': {
        u: 240,
        d: 240,
    },
    'atlantic/azores': {
        u: -60,
        d: -60,
    },
    'atlantic/bermuda': {
        u: -240,
        d: -180,
    },
    'atlantic/canary': {
        u: 0,
        d: 60,
    },
    'atlantic/cape_verde': {
        u: -60,
        d: -60,
    },
    'atlantic/faroe': {
        u: 0,
        d: 60,
    },
    'atlantic/madeira': {
        u: 0,
        d: 60,
    },
    'atlantic/reykjavik': {
        u: 0,
        d: 0,
    },
    'atlantic/south_georgia': {
        u: -120,
        d: -120,
    },
    'atlantic/stanley': {
        u: -180,
        d: -180,
    },
    'australia/sydney': {
        u: 600,
        d: 660,
    },
    'australia/adelaide': {
        u: 570,
        d: 630,
    },
    'australia/brisbane': {
        u: 600,
        d: 600,
    },
    'australia/broken_hill': {
        u: 570,
        d: 630,
    },
    'australia/hobart': {
        u: 600,
        d: 660,
    },
    'australia/darwin': {
        u: 570,
        d: 570,
    },
    'australia/eucla': {
        u: 525,
        d: 525,
    },
    'australia/lord_howe': {
        u: 630,
        d: 660,
    },
    'australia/lindeman': {
        u: 600,
        d: 600,
    },
    'australia/melbourne': {
        u: 600,
        d: 660,
    },
    'australia/perth': {
        u: 480,
        d: 480,
    },
    cet: {
        u: 60,
        d: 120,
    },
    'pacific/easter': {
        u: -360,
        d: -300,
    },
    cst6cdt: {
        u: -360,
        d: -300,
    },
    eet: {
        u: 120,
        d: 180,
    },
    'europe/dublin': {
        u: 0,
        d: 60,
    },
    est: {
        u: -300,
        d: -300,
    },
    est5edt: {
        u: -300,
        d: -240,
    },
    'etc/gmt-0': {
        u: 0,
        d: 0,
    },
    'etc/gmt-1': {
        u: 60,
        d: 60,
    },
    'pacific/port_moresby': {
        u: 600,
        d: 600,
    },
    'etc/gmt-11': {
        u: 660,
        d: 660,
    },
    'pacific/tarawa': {
        u: 720,
        d: 720,
    },
    'etc/gmt-13': {
        u: 780,
        d: 780,
    },
    'etc/gmt-14': {
        u: 840,
        d: 840,
    },
    'etc/gmt-2': {
        u: 120,
        d: 120,
    },
    'etc/gmt-3': {
        u: 180,
        d: 180,
    },
    'etc/gmt-4': {
        u: 240,
        d: 240,
    },
    'etc/gmt-5': {
        u: 300,
        d: 300,
    },
    'etc/gmt-6': {
        u: 360,
        d: 360,
    },
    'indian/christmas': {
        u: 420,
        d: 420,
    },
    'etc/gmt-8': {
        u: 480,
        d: 480,
    },
    'pacific/palau': {
        u: 540,
        d: 540,
    },
    'etc/gmt+1': {
        u: -60,
        d: -60,
    },
    'etc/gmt+10': {
        u: -600,
        d: -600,
    },
    'etc/gmt+11': {
        u: -660,
        d: -660,
    },
    'etc/gmt+12': {
        u: -720,
        d: -720,
    },
    'etc/gmt+3': {
        u: -180,
        d: -180,
    },
    'etc/gmt+4': {
        u: -240,
        d: -240,
    },
    'etc/gmt+5': {
        u: -300,
        d: -300,
    },
    'etc/gmt+6': {
        u: -360,
        d: -360,
    },
    'etc/gmt+7': {
        u: -420,
        d: -420,
    },
    'etc/gmt+8': {
        u: -480,
        d: -480,
    },
    'etc/gmt+9': {
        u: -540,
        d: -540,
    },
    'etc/utc': {
        u: 0,
        d: 0,
    },
    'europe/amsterdam': {
        u: 60,
        d: 120,
    },
    'europe/andorra': {
        u: 60,
        d: 120,
    },
    'europe/astrakhan': {
        u: 240,
        d: 240,
    },
    'europe/athens': {
        u: 120,
        d: 180,
    },
    'europe/london': {
        u: 0,
        d: 60,
    },
    'europe/belgrade': {
        u: 60,
        d: 120,
    },
    'europe/berlin': {
        u: 60,
        d: 120,
    },
    'europe/prague': {
        u: 60,
        d: 120,
    },
    'europe/brussels': {
        u: 60,
        d: 120,
    },
    'europe/bucharest': {
        u: 120,
        d: 180,
    },
    'europe/budapest': {
        u: 60,
        d: 120,
    },
    'europe/zurich': {
        u: 60,
        d: 120,
    },
    'europe/chisinau': {
        u: 120,
        d: 180,
    },
    'europe/copenhagen': {
        u: 60,
        d: 120,
    },
    'europe/gibraltar': {
        u: 60,
        d: 120,
    },
    'europe/helsinki': {
        u: 120,
        d: 180,
    },
    'europe/kaliningrad': {
        u: 120,
        d: 120,
    },
    'europe/kiev': {
        u: 120,
        d: 180,
    },
    'europe/kirov': {
        u: 180,
        d: 180,
    },
    'europe/lisbon': {
        u: 0,
        d: 60,
    },
    'europe/luxembourg': {
        u: 60,
        d: 120,
    },
    'europe/madrid': {
        u: 60,
        d: 120,
    },
    'europe/malta': {
        u: 60,
        d: 120,
    },
    'europe/minsk': {
        u: 180,
        d: 180,
    },
    'europe/monaco': {
        u: 60,
        d: 120,
    },
    'europe/moscow': {
        u: 180,
        d: 180,
    },
    'europe/paris': {
        u: 60,
        d: 120,
    },
    'europe/riga': {
        u: 120,
        d: 180,
    },
    'europe/rome': {
        u: 60,
        d: 120,
    },
    'europe/samara': {
        u: 240,
        d: 240,
    },
    'europe/saratov': {
        u: 240,
        d: 240,
    },
    'europe/simferopol': {
        u: 180,
        d: 180,
    },
    'europe/sofia': {
        u: 120,
        d: 180,
    },
    'europe/stockholm': {
        u: 60,
        d: 120,
    },
    'europe/tallinn': {
        u: 120,
        d: 180,
    },
    'europe/tirane': {
        u: 60,
        d: 120,
    },
    'europe/ulyanovsk': {
        u: 240,
        d: 240,
    },
    'europe/uzhgorod': {
        u: 120,
        d: 180,
    },
    'europe/vienna': {
        u: 60,
        d: 120,
    },
    'europe/vilnius': {
        u: 120,
        d: 180,
    },
    'europe/volgograd': {
        u: 180,
        d: 180,
    },
    'europe/warsaw': {
        u: 60,
        d: 120,
    },
    'europe/zaporozhye': {
        u: 120,
        d: 180,
    },
    hst: {
        u: -600,
        d: -600,
    },
    'indian/chagos': {
        u: 360,
        d: 360,
    },
    'indian/cocos': {
        u: 390,
        d: 390,
    },
    'indian/kerguelen': {
        u: 300,
        d: 300,
    },
    'indian/mahe': {
        u: 240,
        d: 240,
    },
    'indian/maldives': {
        u: 300,
        d: 300,
    },
    'indian/mauritius': {
        u: 240,
        d: 240,
    },
    'indian/reunion': {
        u: 240,
        d: 240,
    },
    'pacific/kwajalein': {
        u: 720,
        d: 720,
    },
    met: {
        u: 60,
        d: 120,
    },
    mst: {
        u: -420,
        d: -420,
    },
    mst7mdt: {
        u: -420,
        d: -360,
    },
    'pacific/chatham': {
        u: 765,
        d: 825,
    },
    'pacific/apia': {
        u: 780,
        d: 840,
    },
    'pacific/bougainville': {
        u: 660,
        d: 660,
    },
    'pacific/chuuk': {
        u: 600,
        d: 600,
    },
    'pacific/efate': {
        u: 660,
        d: 660,
    },
    'pacific/enderbury': {
        u: 780,
        d: 780,
    },
    'pacific/fakaofo': {
        u: 780,
        d: 780,
    },
    'pacific/fiji': {
        u: 720,
        d: 780,
    },
    'pacific/galapagos': {
        u: -360,
        d: -360,
    },
    'pacific/gambier': {
        u: -540,
        d: -540,
    },
    'pacific/guadalcanal': {
        u: 660,
        d: 660,
    },
    'pacific/guam': {
        u: 600,
        d: 600,
    },
    'pacific/honolulu': {
        u: -600,
        d: -600,
    },
    'pacific/kiritimati': {
        u: 840,
        d: 840,
    },
    'pacific/kosrae': {
        u: 660,
        d: 660,
    },
    'pacific/majuro': {
        u: 720,
        d: 720,
    },
    'pacific/marquesas': {
        u: -570,
        d: -570,
    },
    'pacific/pago_pago': {
        u: -660,
        d: -660,
    },
    'pacific/nauru': {
        u: 720,
        d: 720,
    },
    'pacific/niue': {
        u: -660,
        d: -660,
    },
    'pacific/norfolk': {
        u: 660,
        d: 720,
    },
    'pacific/noumea': {
        u: 660,
        d: 660,
    },
    'pacific/pitcairn': {
        u: -480,
        d: -480,
    },
    'pacific/pohnpei': {
        u: 660,
        d: 660,
    },
    'pacific/rarotonga': {
        u: -600,
        d: -600,
    },
    'pacific/tahiti': {
        u: -600,
        d: -600,
    },
    'pacific/tongatapu': {
        u: 780,
        d: 780,
    },
    pst8pdt: {
        u: -480,
        d: -420,
    },
    wet: {
        u: 0,
        d: 60,
    },
};
